<template>
  <div class="mainview_div">
    <header class="common--header">
      <b-row class="marginTopAlignment">
        <b-col cols="2" v-on:click="backAction()"><img src="images/Back_white.svg" alt=""/></b-col>
        <b-col cols="8" class="header-title text-center">REGISTRATION</b-col>
      </b-row>
    </header>
    <div class="listStyle">
      <b-form @submit="onContinue">
        <b-container>
          <b-row>
            <b-col
              ><p class="pre-medical-title">{{ this.premedicalTitle }}</p></b-col
            >
          </b-row>
          <b-row>
            <label class="staticText">{{ this.premedical }}</label>
            <label class="light-staticText">{{ this.selectManyOptions }}</label>
          </b-row>
          <div class="checkbox-div checkboxBgStyle" v-for="item in Items" v-bind:key="item.hcid" :id="item.det">
            <input
              class="checkbox"
              type="checkbox"
              v-on:click="onSelectOption(item, $event)"
              v-model="user.hcids"
              :id="item.det"
              :value="item.det"
            />
            <label class="form-check-label" :for="item.hcid">{{ item.det }}</label>
          </div>
          <div class="continue__controls">
            <label v-if="errorStatus" class="register_errorMessageLabel" id="errorLabel"> {{ errorMessage }} </label>
            <b-button type="login" variant="" v-on:click="onContinue">COMPLETE REGISTRATION</b-button>
          </div>
        </b-container>
      </b-form>
    </div>
    <b-modal ref="error-modal" class="verticalCenterAlign" centered hide-header hide-footer>
      <label class="thankyouText">{{ premedicalPopup }}</label>
      <div class="rightAlign">
        <a href="javascript:void(0);" @click="exitModal" class="exitHyperLinkStyle"> {{ this.ok }}</a>
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      Items: "",
      user: {
        did: "uudduuud23423432",
        hcids: [],
      },

      store: store,
      checkboxSelected: [],
      selectedItem: {
        did: "uudduuud23423432",
        hcids: [],
      },
      errorStatus: false,
      errorMessage: "",
    };
  },
  methods: {
    exitModal() {
      this.$refs["error-modal"].hide();
    },
    backAction() {
      this.$router.push({ path: "/personal-details" });
    },
    onContinue(evt) {
      evt.preventDefault();

      for (var i = 0; i < this.user.hcids.length; i++) {
        this.user.hcids[i];
        for (var j = 0; j < this.Items.length; j++) {
          if (this.Items[j].det == this.user.hcids[i]) {
            this.selectedItem.hcids.push(this.Items[j].hcid);
          }
        }
      }
      if (this.selectedItem.hcids.length == 0) {
        this.$refs["error-modal"].show();
      } else {
        if (navigator.onLine) {
        var header = {}
        //   headers: [
        //     {
        //       key: "Content-Type",
        //       value: "application/json",
        //       type: "text",
        //     },
        //   ],
        // };
        
        var urlString = "/user/register/".concat(store.registration.iid);
        apiCall
          .apiServiceCall("Post", "", urlString, this.selectedItem, header)
          .then(response => {
              if (response.data.status == 1) {
                store.registrationSuccessResponse = response.data.message;
                // const data = JSON.stringify(response.data.data.iid);
                // window.localStorage.setItem("iid", data);
                var CryptoJS = require("crypto-js");
                var eml  = CryptoJS.AES.encrypt(response.data.data.eml, 'eml').toString();
                window.localStorage.setItem("LI3EIB", eml);//Password

                this.$router.push({ path: "/registration_success" });
              } else {
                this.errorStatus = true;
                this.errorMessage = response.data.message;
              }
          })
          .catch(error => {
            if (error.response.status == 500) {
              this.errorStatus = true;
              this.errorMessage = this.serverProblem;
            } else if (error.response.status == 401) {
              setTimeout(() => this.$router.push({ path: "/home" }), 2000);
            } else if (error.response.status == 504) {
              this.signout();
            }  else {
              this.errorStatus = true;
              this.errorMessage = error.response.data.message;
            }
          });

        } else {
          this.errorStatus = true;
          this.errorMessage = this.checkInternetConnection;
        }
      }
    },
    onSelectOption(symptom, event) {
      this.checkboxSelected.push(symptom.det);
      if (symptom.det == "None of the above") {
        for (let i = 0; i < this.checkboxSelected.length; i++) {
          document.getElementById(this.checkboxSelected[i]).checked = false;
          document.getElementById(this.checkboxSelected[i]).className = "checkbox-div checkboxBgStyle";
          document.getElementById("None of the above").checked = true;
          this.user.hcids = [];
          this.user.hcids.push(symptom.det);
        }
      } else {
        this.user.hcids.push(symptom.det);
      }
      if (symptom.det != "None of the above") {
        document.getElementById("None of the above").checked = false;
        document.getElementById("None of the above").className = "checkbox-div checkboxBgStyle";
        for (let i = 0; i < this.user.hcids.length; i++) {
          if (this.user.hcids[i] == "None of the above") {
            this.user.hcids.splice(this.user.hcids.indexOf("None of the above"), 1);
          }
        }
      }

      if (event.target.checked) {
        document.getElementById(symptom.det).className = "checkbox-div-WithBackground checkboxBgStyle";
      } else {
        this.user.hcids.splice(this.user.hcids.indexOf(symptom.det), 1);
        document.getElementById(symptom.det).className = "checkbox-div checkboxBgStyle";
      }
    },
  },
  mounted() {
    if (navigator.onLine) {
    apiCall
      .apiServiceCall("Get", "", "/pre-health-condition/", "", "")
      .then(response => {
          if (response.data.status == 1) {
            this.Items = response.data.data;
          } else {
            this.errorStatus = true;
            this.errorMessage = response.data.message;
          }
      })
      .catch(error => {
        if (error.response.status == 500) {
          this.errorStatus = true;
          this.errorMessage = this.serverProblem;
        } else if (error.response.status == 401) {
          setTimeout(() => this.$router.push({ path: "/home" }), 2000);
        } else if (error.response.status == 504) {
          this.signout();
        }  else {
          this.errorStatus = true;
          this.errorMessage = error.response.data.message;
        }
      });

    } else {
      this.errorStatus = true;
      this.errorMessage = this.checkInternetConnection;
    }
  },
};
</script>
